// Packages
import { useContext, useState, useEffect } from "react";

// Context
import { Language } from "../../Language/Language";

// Elements
import {
  Container,
  Title,
  Standfirst,
  Paragraph,
  TcLink,
  TcLinkExt,
  TopBanner,
  HotelRestaurantInfo,
  ModalMask,
} from "./Intro.elements";

// Components
import TsAndCsModal from "./TsAndCsModal.js";
import ToTopButton from "../Common/ToTopButton";

export default function Intro({ countryCount, locale, hasInHotel }) {
  const { intro } = useContext(Language);
  const { title, standfirst, paragraph, topBanner, tcLinkUrl, tcLink, hotelRestaurant } =
    intro;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openTsAndCsModal = () =>  {
    window.tuiTrack.trackEvent('click', `openTermsLink:${locale}`)
    setIsModalOpen(true)
  };
  const closeTsAndCsModal = () => {
    window.tuiTrack.trackEvent('click', `closeTermsLink:${locale}`)
    setIsModalOpen(false)
  };

  function setCount(copy) {
    if (typeof copy === "string" && copy.includes("%COUNT%")) {
      return copy.replace(/%COUNT%/, countryCount);
    }
    return copy;
  }

  // Handle body scroll lock
  useEffect(() => {
    if (isModalOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
    return () => document.body.classList.remove("no-scroll"); // Cleanup on unmount
  }, [isModalOpen]);

  return (
    <>
      <Container>
        <Title>{title}</Title>
        <Standfirst className={locale === 'de-de' ? 'de' : ''}>
          {standfirst}
        </Standfirst>
        <Paragraph
          dangerouslySetInnerHTML={{
            __html: setCount(paragraph) || "",
          }}
        ></Paragraph>
        { tcLinkUrl
            ? <TcLinkExt
                rel="noopener noreferrer"
                target="_blank"
                href={tcLinkUrl}
              > {tcLink}</TcLinkExt>
            : <TcLink onClick={openTsAndCsModal}> {tcLink} </TcLink>
        }
        {isModalOpen && <ModalMask />}
        <TsAndCsModal isOpen={isModalOpen} onClose={closeTsAndCsModal}></TsAndCsModal>

        {hasInHotel &&
          (locale !== "fr-ca" || locale !== "en-ca") &&
          hotelRestaurant !== "" && (
            <HotelRestaurantInfo>{hotelRestaurant}</HotelRestaurantInfo>
          )}
        {topBanner &&
          topBanner.show &&
          topBanner.heading &&
          topBanner.description && (
            <TopBanner>
              <h2 className={"text-2xl font-medium"}>{topBanner.heading}</h2>
              <div>{topBanner.description}</div>
            </TopBanner>
          )}
      </Container>
      <ToTopButton />
    </>
  );
}
